var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab,idx){return _c('div',{key:idx,class:'tabs__tab' + (tab.name == _vm.active ? ' active' : ''),on:{"click":function($event){return _vm.$emit('input', _vm.name, tab.name)}}},[_vm._v(_vm._s(tab.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }